import { Injectable } from '@angular/core';
import {BehaviorSubject, Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class MenuStateService {

  menuState$: Subject<boolean> = new BehaviorSubject(false)

}
